import { NavbarProvider } from './NavbarContext';
import { AiChatToggleButton } from '../ai/AiChatToggleButton';

/**
 * Right-hand header CTA: AI chat.
 *
 * The user menu lives in Navigation.yaml now (config-first: a Switch over
 * ~~.accountMenu, like the main menu) — it is NOT rendered here anymore.
 * Notification & Activity bells were intentionally removed from the header
 * (see docs/frontend/refonte-menu-global-spec.md §3), and so was the help
 * center (FAQ panel).
 */
export default function NavbarActions() {
    return (
        <NavbarProvider>
            <div className="flex items-center gap-2 sm:gap-4 lg:gap-5">
                <AiChatToggleButton />
            </div>
        </NavbarProvider>
    );
}
